var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 118.824,
    r: 52,
    fill: "#F2A4B9",
    stroke: "#313D53",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149 71.994C150.233 62.9014 160.019 54.1543 169.415 55.7536C176.046 56.8822 183 63.994 175.297 67.9937C165 71.994 166.748 61.201 167 58.994C167.739 52.5305 177.167 48.5994 182.394 47.6859C186.239 47.014 189.905 46.8237 193.803 46.8237",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97656 146.515L6.73224 152.417",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3652 129.609C22.7216 128.023 18.5376 124.574 15.2952 124.574",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7307 100.439C12.7307 102.105 11.3699 103.554 9.61534 103.554C7.86073 103.554 6.5 102.105 6.5 100.439C6.5 98.806 7.98225 97.3237 9.61534 97.3237C11.2484 97.3237 12.7307 98.806 12.7307 100.439Z",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.731 59.4391C138.731 61.1048 137.37 62.5544 135.615 62.5544C133.861 62.5544 132.5 61.1048 132.5 59.4391C132.5 57.806 133.982 56.3237 135.615 56.3237C137.248 56.3237 138.731 57.806 138.731 59.4391Z",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4492 161.699L20.874 153.824L12.9991 165.399C19.3919 169.748 28.1 168.092 32.4492 161.699Z",
    fill: "#E9688A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.216 41.4472C113.958 43.9908 116.15 46.1123 116.919 48.4199",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.17 44.4111L163.589 40.4186L159.596 27C152.185 29.205 147.965 37.0002 150.17 44.4111Z",
    fill: "#E9688A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79 120.667L92.3333 134L121.667 102",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8662 124.667L96.6995 135.5L120.533 109.5",
    stroke: "#313D53",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e4074e1466611bf61129ea5505b895d2.svg";
export { ForwardRef as ReactComponent };